const IMAGE_CARDS_DESKTOP_MQ = '(min-width: 750px)';

const initImageCardsCarousel = (emblaComponent) => {
  if (emblaComponent.classList.contains('image-cards__embla') === false) return;

  const mediaQuery = window.matchMedia(IMAGE_CARDS_DESKTOP_MQ);
  let isDestroyed = false;

  const syncCarousel = () => {
    const isDesktop = mediaQuery.matches === true;

    emblaComponent.classList.toggle('image-cards__embla--static', isDesktop);

    if (isDesktop === true) {
      if (emblaComponent.emblaApi && isDestroyed === false) {
        emblaComponent.emblaApi.destroy();
        isDestroyed = true;
      }
      return;
    }

    if (isDestroyed === true) {
      emblaComponent.init();
      isDestroyed = false;
    }
  };

  const waitForApi = () => {
    if (!emblaComponent.emblaApi) {
      requestAnimationFrame(waitForApi);
      return;
    }

    syncCarousel();
    mediaQuery.addEventListener('change', syncCarousel);
  };

  waitForApi();
};

const initImageCardsCarousels = (root = document) => {
  root
    .querySelectorAll('embla-component.image-cards__embla')
    .forEach(initImageCardsCarousel);
};

document.addEventListener('DOMContentLoaded', () => initImageCardsCarousels());

document.addEventListener('shopify:section:load', (event) => {
  const section = document.querySelector(`#shopify-section-${event.detail.sectionId}`);
  if (section) initImageCardsCarousels(section);
});
